import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup'
import SegmentedToggleButton from 'components/segmented-toggle-button'
import { useAuth } from 'lib/auth'
import { useStyles } from 'pages/pga-coach/bookings/events/edit/edit-event-form/styles'

const CreateEventWaitlist = () => {
  const classes = useStyles()
  const { control, watch } = useFormContext()
  const { user } = useAuth()
  const tags = watch('tags')
  const maxAttendance = watch('maxAttendance')
  const hasPaidTierSubscription = user?.coach?.hasPaidTierSubscription
  const isPgaHopeEvent = tags?.includes('PGA HOPE')
  const showWaitlistOption =
    (hasPaidTierSubscription || isPgaHopeEvent) &&
    maxAttendance !== null &&
    maxAttendance !== undefined &&
    maxAttendance !== ''

  if (!showWaitlistOption) return null

  return (
    <Box className={classes.fieldGroup}>
      <Typography className={classes.sectionHeading}>Waitlist</Typography>
      <Typography className={classes.fieldHelper}>
        Collect a waitlist and contact students if a spot becomes available.
      </Typography>
      <Controller
        name="waitlistEnabled"
        control={control}
        render={({ value, onChange }) => (
          <ToggleButtonGroup
            exclusive
            value={value ? 'yes' : 'no'}
            onChange={(_, nextValue) => {
              if (!nextValue) return
              onChange(nextValue === 'yes')
            }}
            aria-label="Waitlist"
          >
            <SegmentedToggleButton
              value="yes"
              groupValue={value ? 'yes' : 'no'}
              data-cy="waitlistToggle"
            >
              Yes
            </SegmentedToggleButton>
            <SegmentedToggleButton
              value="no"
              groupValue={value ? 'yes' : 'no'}
              data-cy="waitlistToggle"
            >
              No
            </SegmentedToggleButton>
          </ToggleButtonGroup>
        )}
      />
    </Box>
  )
}

export default CreateEventWaitlist
